import { LANGUAGES } from '../../constants';
import { StyleLayout } from '../components';
import type { StyleProps } from './types';

export function Style4({ items, onClick }: StyleProps) {
  return items?.map(({ id, language }, _, { length }) => {
    const { originalName } = LANGUAGES[language];
    const handleClick = () => onClick(language);

    return (
      <StyleLayout.Container
        key={id}
        itemsLength={length}
        languageCode={language}
        onClick={handleClick}
        withSlash
      >
        <StyleLayout.Name name={originalName} />
      </StyleLayout.Container>
    );
  });
}
